export const setFields = (object: any, fields: Array<any>, value: any) => {
  for (const field of fields) {
    object[field] = value;
  }

  return object;
};
